/**
 * @flow
 * @relayHash 19bacf0f25275d9fbc4bac13e8884a14
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ForgotPasswordInput = {|
  email: string,
  clientMutationId?: ?string,
|};
export type ForgotPasswordMutationVariables = {|
  input: ForgotPasswordInput
|};
export type ForgotPasswordMutationResponse = {|
  +forgotPassword: ?{|
    +message: ?string,
    +clientMutationId: ?string,
  |}
|};
export type ForgotPasswordMutation = {|
  variables: ForgotPasswordMutationVariables,
  response: ForgotPasswordMutationResponse,
|};
*/


/*
mutation ForgotPasswordMutation(
  $input: ForgotPasswordInput!
) {
  forgotPassword(input: $input) {
    message
    clientMutationId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ForgotPasswordInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "forgotPassword",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ForgotPasswordPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "message",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ForgotPasswordMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ForgotPasswordMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "ForgotPasswordMutation",
    "id": null,
    "text": "mutation ForgotPasswordMutation(\n  $input: ForgotPasswordInput!\n) {\n  forgotPassword(input: $input) {\n    message\n    clientMutationId\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6ef7e132293740f442cb865b20b3ec57';
module.exports = node;
